import { createFileRoute } from '@tanstack/react-router';

import { BidsPage } from '@/features/operator/bids-page';
import { validatePortSearch } from '@/features/operator/list-search';

export const Route = createFileRoute('/_operator/bids')({
	// Стан списку і вибрана ставка — в адресі (§11 гайду).
	validateSearch: validatePortSearch,
	component: BidsPage,
});
